import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import EjectErrorChrome from "./EjectErrorChrome";
import ErrorView from "./ErrorView";

const OuterErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [crashGen, setCrashGen] = useState(0);

  return (
    <ErrorBoundary
      key={crashGen}
      fallback={
        <EjectErrorChrome
          onGoHome={() => {
            navigate("/", { replace: true });
            setCrashGen((generation) => generation + 1);
          }}
        >
          <ErrorView />
        </EjectErrorChrome>
      }
    >
      {children}
    </ErrorBoundary>
  );
};

export default OuterErrorBoundary;
